import { render, staticRenderFns } from "./Addtask.vue?vue&type=template&id=6f4c3fb9&scoped=true&"
import script from "./Addtask.vue?vue&type=script&lang=ts&"
export * from "./Addtask.vue?vue&type=script&lang=ts&"
import style0 from "./Addtask.vue?vue&type=style&index=0&id=6f4c3fb9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c3fb9",
  null
  
)

export default component.exports